import { DependencyType, type Item } from '@/lib/api/types/items';
import { useItemHealth } from '@/lib/hooks/dashboard/useItemHealth';
import { useSuspenseGetItemStatusesQuery } from '@/lib/queries/common/useGetItemStatusesQuery';
import { useItemsBulkFetchQuery } from '@/lib/queries/common/useGetItemsBulkFetchQuery';
import { useSuspenseItemTypesQuery } from '@/lib/queries/common/useItemTypesQuery';

const PANEL_QUERY_OPTIONS = {
  refetchOnMount: false,
} as const;

export function useItemDependenciesPanelQuery(item: Item) {
  const { data: itemStatuses = [] } = useSuspenseGetItemStatusesQuery(PANEL_QUERY_OPTIONS);
  const { data: itemTypes = [] } = useSuspenseItemTypesQuery(PANEL_QUERY_OPTIONS);

  const predecessorsIds = item.dependencies
    .filter((dep) => dep.dependencyType === DependencyType.Predecessor)
    .map((dep) => dep.dependencyItemId);
  const successorsIds = item.dependencies
    .filter((dep) => dep.dependencyType === DependencyType.Successor)
    .map((dep) => dep.dependencyItemId);

  const { data: dependencies = [] } = useItemsBulkFetchQuery({
    itemIds: [...predecessorsIds, ...successorsIds],
  });

  useItemHealth({ itemIds: [...predecessorsIds, ...successorsIds] });

  const predecessors = dependencies.filter((dep) => predecessorsIds.includes(dep.id));
  const successors = dependencies.filter((dep) => successorsIds.includes(dep.id));

  return { dependencies, itemStatuses, itemTypes, predecessors, successors };
}
